import { motion } from "framer-motion";
import { GlassCard } from "@/components/GlassCard";
import { fadeUp } from "@/lib/motion";
import { cn } from "@/lib/utils";

export const Chip = ({ selected, onClick, children, testId, className }) => (
  <button
    type="button"
    data-testid={testId}
    onClick={onClick}
    className={cn(
      "rounded-full px-4 py-2.5 text-sm font-medium border transition-colors duration-200 active:scale-[0.97]",
      selected
        ? "bg-cyan-300/90 text-slate-950 border-cyan-300"
        : "bg-white/5 border-white/10 text-white/85 hover:bg-white/10",
      className
    )}
  >
    {children}
  </button>
);

export const FormSection = ({ title, children, delay = 0 }) => (
  <motion.div {...fadeUp(delay)}>
    <GlassCard className="p-4">
      <p className="text-xs font-medium text-[hsl(var(--muted-foreground))] uppercase tracking-wider mb-3">
        {title}
      </p>
      {children}
    </GlassCard>
  </motion.div>
);
